import { render } from "./AnnotationSetsWidget.vue?vue&type=template&id=5bc5c259&scoped=true"
import script from "./AnnotationSetsWidget.vue?vue&type=script&lang=js"
export * from "./AnnotationSetsWidget.vue?vue&type=script&lang=js"

import "./AnnotationSetsWidget.vue?vue&type=style&index=0&id=5bc5c259&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc5c259"]])

export default __exports__